
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holiday-gift",
      function () {
        return require("private-next-pages/holiday-gift.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holiday-gift"])
      });
    }
  